var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAppleCareLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.1367 2.78455C19.2395 0.0136679 22.1623 0 22.1623 0C22.1623 0 22.597 2.60529 20.5085 5.11544C18.278 7.79538 15.7432 7.35696 15.7432 7.35696C15.7432 7.35696 15.2669 5.24896 17.1367 2.78455Z",
    fill: "#D0112B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0101 9.18164C17.0919 9.18164 19.099 7.69501 21.7122 7.69501C26.2099 7.69501 27.9794 10.8954 27.9794 10.8954C27.9794 10.8954 24.5188 12.6648 24.5188 16.9581C24.5188 21.8012 28.83 23.4703 28.83 23.4703C28.83 23.4703 25.8162 31.9527 21.7458 31.9527C19.876 31.9527 18.423 30.6927 16.4527 30.6927C14.4451 30.6927 12.4533 31.9995 11.1559 31.9995C7.4388 32 2.74286 23.9539 2.74286 17.4859C2.74286 11.1225 6.71756 7.78437 10.4457 7.78437C12.8696 7.78385 14.7505 9.18164 16.0101 9.18164Z",
    fill: "#D0112B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppleCareLogo);
export default __webpack_public_path__ + "static/media/AppleCareLogo.8064cd3c2930bde48ff036adc6206e96.svg";
export { ForwardRef as ReactComponent };